<div class="p-5">
  <div class="flex justify-between items-center mb-4">
    <h3>
      @if(viewEdit){
      Visualizar Agendamento
      }@else{
      Editar Agendamento
      }
    </h3>
    <div class="flex gap-2">
      <button mat-button class="btn-tg-cancel" (click)="close()">Fechar</button>
      <button mat-button class="btn-tg" (click)="toSendBuys()" [disabled]="viewEdit || definet"
        [hidden]="viewEdit">Enviar para
        Compras</button>
      <button mat-button class="btn-tg" [disabled]="!driverDates || !vehicleDates || loading" [hidden]="viewEdit"
        (click)="pushdates()">
        @if(loading){
        <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
        }@else{
        Escalar
        }
      </button>
    </div>
  </div>


  <!-- <div class="flex flex-col gap-5">
        <app-schedule-vehicle [dataVehicle]="data"></app-schedule-vehicle>
        <app-schedule-driver [dataDriver]="data"></app-schedule-driver>
    </div> -->
</div>

<div [formGroup]="form" class="flex flex-col mt-4 mx-auto w-full">
  <div class="flex flex-row justify-between items-center w-full">
    <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Data Inicio</mat-label>
      <input matInput [matDatepicker]="dateInitial" formControlName="dateInitial" readonly />
      <mat-datepicker-toggle matSuffix [for]="dateInitial" [disabled]="true"></mat-datepicker-toggle>
      <mat-datepicker #dateInitial></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Data Fim</mat-label>
      <input matInput [matDatepicker]="dateEnd" formControlName="dateEnd" readonly />
      <mat-datepicker-toggle matSuffix [for]="dateEnd" [disabled]="true"></mat-datepicker-toggle>
      <mat-datepicker #dateEnd></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Hora Inicial</mat-label>
      <input matInput type="time" formControlName="startHours" readonly />
    </mat-form-field>
    <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Hora Final</mat-label>
      <input matInput type="time" formControlName="endHours" readonly />
    </mat-form-field>
  </div>

  <div class="flex flex-row justify-between items-center w-full">
    <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Evento</mat-label>
      <input matInput formControlName="event" readonly />

    </mat-form-field>
    <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Tipo Serviço</mat-label>
      <input matInput formControlName="typeService" readonly />
    </mat-form-field>

    <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Serviço</mat-label>
      <input matInput formControlName="service" readonly />

    </mat-form-field>

    <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Status</mat-label>
      <input matInput formControlName="status" readonly />
    </mat-form-field>
  </div>


</div>

<mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="400ms">

  <mat-tab label="Veiculo">
    <!--  <mat-tab label="Jurídico">-->
    <app-schedule-vehicle [dataVehicle]="data" [view]="viewEdit" (response)="captureDateVehicle($event)"
      (responseIndex)="goToTab(1)" (checkboxChange)="onCheckboxChangeVehicle($event)"></app-schedule-vehicle>
  </mat-tab>

  <!--  <mat-tab label="Fisico" disabled>-->
  <!--    <individual-client></individual-client>-->
  <!--  </mat-tab>-->

  <mat-tab label="Motorista">
    <app-schedule-driver [dataDriver]="data" [view]="viewEdit" (response)="finalize($event)"
      (checkboxChange)="onCheckboxChangeDriver($event)"></app-schedule-driver>
  </mat-tab>

</mat-tab-group>